import React from 'react';

import { Checkbox } from "primereact/checkbox";
import { getPMCompanyConfig } from '../../../setup/pmCompanyConfig';
import { useSelector } from 'react-redux';


const AddrAndGSTINConfirmDialog = (props) => {
    const { raisePOData, buyerBillAddrDetails, buyerShipAddrDetails, pmCompanyBillAddrDetails, companyCreditPeriods, setAddressAndGSTINDeclaration, addressAndGSTINDeclaration } = props
    const { buyerPo } = raisePOData

    const userDetails = useSelector(state => state.userDetails)
    const pmCompanyConfig = getPMCompanyConfig(userDetails.PMCompanyDetails.companyId)

    const handleDeclarationOnChange = (name, checked) => {
        setAddressAndGSTINDeclaration({...addressAndGSTINDeclaration, [name]: checked})
    }

    let relatedBuyerBillAddr = buyerBillAddrDetails.find(eachBillAddr => eachBillAddr.billAddrId === buyerPo.billAddrId)
    let relatedBuyerShipAddr = buyerShipAddrDetails.find(eachShipAddr => eachShipAddr.shipAddrId === buyerPo.shipAddrId)

    let relatedBillingAddrState = props.stateList.find(state => state.stateId === parseInt(relatedBuyerBillAddr.stateId))
    let relatedShippingAddrState = props.stateList.find(state => state.stateId === parseInt(relatedBuyerShipAddr.stateId))


    let paymentTermsString = ""

    if (buyerPo?.paymentTerms) {
        if (buyerPo.paymentTerms?.payAdvDelivery) {
            paymentTermsString += `AdvDelivery ${buyerPo.paymentTerms.payAdvDelivery}, `
        }

        if (buyerPo.paymentTerms?.payAdvPO) {
            paymentTermsString += `AdvPO ${buyerPo.paymentTerms.payAdvPO}, `
        }

        if (buyerPo.paymentTerms?.payOnDelivery) {
            paymentTermsString += `OnDelivery ${buyerPo.paymentTerms.payOnDelivery}, `
        }

        if (buyerPo.paymentTerms?.payCredit || buyerPo.paymentTerms?.payPDCDelivery) {
            let relatedCreditPeriod = companyCreditPeriods.find(eachCreditPeriod => eachCreditPeriod.creditPeriodId === buyerPo.paymentTerms?.creditPeriodId)
            if(buyerPo.paymentTerms.payCredit){
                paymentTermsString += `Credit (${relatedCreditPeriod.creditPeriodName}), `
            }

            if (buyerPo.paymentTerms.payPDCDelivery) {
                paymentTermsString += `PDCDelivery (${relatedCreditPeriod.creditPeriodName}), `
            }
        }
    }

    if (paymentTermsString.endsWith(", ")) {
        paymentTermsString = paymentTermsString.slice(0, -2)
    }
    
    return (
        <div className="">
            {/* <div className="dispatch-note-list mb-3 flex flex-row justify-content-between">
                <div style={{ width: "100%"}}>
                    <h5 className="text-600 mt-2 mb-2">Billing Address</h5>
                    <div className="flex flex-row">
                        <Checkbox onChange={e => setBillAddrDeclaration(e.checked)} checked={billAddrDeclaration}></Checkbox>
                        <div className="flex flex-column ml-1">
                            <div key={relatedBuyerBillAddr.billAddrId} className="flex flex-column col-12 w-auto border-around-1 m-2 border-round justify-content-between text-xs" style={{ backgroundColor: '#f5f5f5' }}>
                            <div className='flex p-1 flex-column'>
                                <div className=''><span className='text-900 font-medium'>Address:</span> {relatedBuyerBillAddr?.billAddress} </div>
                                <div className=''><span className='text-900 font-medium'>State:</span> {relatedBillingAddrState?.stateName} </div>
                                <div className=''><span className='text-900 font-medium'>Pin:</span> {relatedBuyerBillAddr?.pinCode} </div>
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div  className="ml-2" style={{ width: "100%"}}>
                    <h5 className="text-600 mt-2 mb-2">Shipping Address</h5>
                    <div className="flex flex-row">
                        <Checkbox onChange={e => setShipAddrDeclaration(e.checked)} checked={shipAddrDeclaration}></Checkbox>
                        <div className="flex flex-column ml-1">
                            <div key={relatedBuyerShipAddr.shipAddrId} className="flex flex-column w-auto col-12 border-around-1 m-2 border-round justify-content-between text-xs" style={{ backgroundColor: '#f5f5f5' }}>
                            <div className='flex p-1 flex-column'>
                                    <div className=''><span className='text-900 font-medium'>Address:</span> {relatedBuyerShipAddr?.shipAddr} </div>
                                    <div className=''><span className='text-900 font-medium'>State:</span> {relatedShippingAddrState?.stateName} </div>
                                    <div className=''><span className='text-900 font-medium'>Pin:</span> {relatedBuyerShipAddr?.pinCode} </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}
            <div className="address-container my-4">
                <Checkbox onChange={e => handleDeclarationOnChange("billAddrDeclaration", e.checked)} checked={addressAndGSTINDeclaration.billAddrDeclaration}></Checkbox>
                <div className="address-card billing-address">
                    <h4>Billing Address</h4>
                    <div className='flex p-1 flex-column'>
                        <div className='font-medium'><span className='text-900 font-medium'>Address:</span> {relatedBuyerBillAddr?.billAddress} </div>
                        <div className='font-medium'><span className='text-900 font-medium'>State:</span> {relatedBillingAddrState?.stateName} </div>
                        <div className='font-medium'><span className='text-900 font-medium'>Pin:</span> {relatedBuyerBillAddr?.pinCode} </div>
                    </div>
                </div>
                <Checkbox onChange={e => handleDeclarationOnChange("shipAddrDeclaration", e.checked)} checked={addressAndGSTINDeclaration.shipAddrDeclaration}></Checkbox>
                <div className="address-card shipping-address">
                    <h4>Shipping Address</h4>
                    <div className='flex p-1 flex-column'>
                        <div className='font-medium'><span className='text-900 font-medium'>Address:</span> {relatedBuyerShipAddr?.shipAddr} </div>
                        <div className='font-medium'><span className='text-900 font-medium'>State:</span> {relatedShippingAddrState?.stateName} </div>
                        <div className='font-medium'><span className='text-900 font-medium'>Pin:</span> {relatedBuyerShipAddr?.pinCode} </div>
                    </div>
                </div>
            </div>

            <div className="flex flex-row mb-2">
                <Checkbox onChange={e => handleDeclarationOnChange("PMGSTINDeclaration", e.checked)} checked={addressAndGSTINDeclaration.PMGSTINDeclaration} style={{ textAlign: "center" }} ></Checkbox>
                <label style={{ marginBottom: "5px", fontSize: "13px", marginLeft: "8px" }} >Procmart {pmCompanyConfig.GSTINLabel}:<span className="font-bold ml-1">{pmCompanyBillAddrDetails?.gstinCode}</span></label>
            </div>
            <div className="flex flex-row mb-2">
                <Checkbox onChange={e => handleDeclarationOnChange("buyerGSTINDeclaration", e.checked)} checked={addressAndGSTINDeclaration.buyerGSTINDeclaration} style={{ textAlign: "center" }} ></Checkbox>
                <label style={{ marginBottom: "5px", fontSize: "13px", marginLeft: "8px" }} >Buyer {pmCompanyConfig.GSTINLabel}:<span className="font-bold ml-1">{relatedBuyerBillAddr?.gstinCode}</span></label>
            </div>
            <div className="flex flex-row mb-2">
                <Checkbox onChange={e => handleDeclarationOnChange("paymentTermsDeclaration", e.checked)} checked={addressAndGSTINDeclaration.paymentTermsDeclaration} style={{ textAlign: "center" }} ></Checkbox>
                <label style={{ marginBottom: "5px", fontSize: "13px", marginLeft: "8px" }} >Payment Terms:<span className="font-bold ml-1">{paymentTermsString}</span></label>
            </div>
        </div>
    )
}

export default AddrAndGSTINConfirmDialog